import { render, staticRenderFns } from "./ModalSendDG.vue?vue&type=template&id=79799bf2&"
import script from "./ModalSendDG.vue?vue&type=script&lang=js&"
export * from "./ModalSendDG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports